module.exports = __webpack_public_path__ + "static/media/flag_mounted_2.f87258af.png";